import { conversionBooleanoJson, conversionFechaJson, conversionNumberJson, conversionStringJson, convertirFechaFirebase } from "./utiles_objetos";

export class cuentaCobroTutor{
    constructor({
        idDocumento = "",
        idPago = 0,

        fechaPago = new Date(), //fecha cobrada por el tutor
        fechaPagadoPorNosotros = new Date(),
        referenciaPago = "",

        precioCobro = 0,
        urlArchivo = "",  //url de cuenta de cobro del tutor
        estado = false,
        nameTutor = "",

        precioPagado = 0,
        ultimaModificacion = 0,
        autoPagos = false, //que es?

    } = {}){
        this.idDocumento = idDocumento;
        this.idPago = idPago;

        this.fechaPago = fechaPago; //por tutor
        this.fechaPagadoPorNosotros = fechaPagadoPorNosotros;
        this.referenciaPago = referenciaPago;

        this.precioCobro = precioCobro;
        this.urlArchivo = urlArchivo;
        this.estado = estado;
        this.nameTutor = nameTutor;

        this.precioPagado = precioPagado;
        this.ultimaModificacion = ultimaModificacion;
        this.autoPagos = autoPagos;


    }

    static fromJson(json){
        const fechaPagoPorTutor = convertirFechaFirebase(json['fechaPago']);
        const fechaPagadoPorNosotrosLocal = convertirFechaFirebase(json['fechaPagadoPorNosotros']);

        return new cuentaCobroTutor({
            idDocumento: json['idDocumento'] ?? '',
            idPago: json['idPago'] ?? 0,

            fechaPago: fechaPagoPorTutor,
            fechaPagadoPorNosotros: fechaPagadoPorNosotrosLocal,
            referenciaPago: json['referenciaPago'] ?? '',

            precioCobro: json['precioCobro'] ?? 0,
            urlArchivo: json['urlArchivo'] ?? '',
            estado: json['estado'] ?? false,
            nameTutor: json['nameTutor'] ?? '',

            precioPagado: json['precioPagado'] ?? 0,
            ultimaModificacion: json['ultimaModificacion'] ?? 0,
            autoPagos: json['ultimaModificacion'] ?? false,

        });
    }

    toJson(){
        
    }

    toMap(){
        return{
            'idPago' : conversionNumberJson(this.idPago),
            "fechaPago" : conversionFechaJson(this.fechaPago),
            "precioCobro": conversionNumberJson(this.precioCobro),
            'urlArchivo': conversionStringJson(this.urlArchivo),
            //'estado': conversionStringJson(this.estado), //en backend poner false
            'nameTutor' : conversionStringJson(this.nameTutor),
            //'ultimaModificacion' : conversionNumberJson(this.ultimaModificacion), //en backend ultima modificacion
        }
    }

    updateFromJson(updateData){
        if (!updateData || typeof updateData !== 'object') {
            console.warn('updateData debe ser un objeto válido');
            return;
        }

        Object.keys(updateData).forEach(field => {
            const value = updateData[field];
            console.log(`🔧 Procesando campo: ${field}, tipo: ${typeof value}`);
                
            switch(field) {
        
                case 'idDocumento':
                    this.idDocumento = conversionStringJson(value, this.idDocumento);
                    break;

                case 'idPago':
                    this.idPago = conversionNumberJson(value, this.idPago);
                    break;

                case 'fechaPago':
                    this.fechaPago = conversionFechaJson(value, this.fechaPago);
                    break;

                case 'fechaPagadoPorNosotros':
                    this.fechaPagadoPorNosotros = conversionFechaJson(value, this.fechaPagadoPorNosotros);
                    break;

                case 'referenciaPago':
                    this.referenciaPago = conversionStringJson(value, this.referenciaPago);
                    break;

                case 'precioCobro':
                    this.precioCobro = conversionNumberJson(value, this.precioCobro);
                    break;

                case 'urlArchivo':
                    this.precioCobro = conversionStringJson(value, this.urlArchivo);
                    break;

                case 'estado':
                    this.estado = conversionBooleanoJson(value, this.estado);
                    break;

                case 'nameTutor':
                    this.nameTutor = conversionStringJson(value, this.nameTutor);
                    break;

                case 'precioPagado':
                    this.precioPagado = conversionNumberJson(value, this.precioPagado);
                    break;

                case 'autoPagos':
                    this.autoPagos = conversionBooleanoJson(value, this.autoPagos);
                    break;
                    
                default:
                    console.warn(`Campo desconocido en update data de Solicitudes: ${field}`);
                    break;
                    
            }
        });
    }

    getFieldValue(fieldPath){
        if (fieldPath.includes('.')) {
            const [objectName, fieldName] = fieldPath.split('.');
            const value = this[objectName]?.[fieldName];
            console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
            return value;
        }
        
        const value = this[fieldPath];
        console.log(`📝 Valor directo ${fieldPath}:`, value);
        return value;
    }

}